import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc SingleSelectAndSearch defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { SingleSelectAndSearchService } from 'services/singleSelectAndSearch';
 *
 * // create service instance and send/cancel request
 * const singleSelectAndSearchService = new SingleSelectAndSearchService();
 * const result = await singleSelectAndSearchService.fetchData( '<user-id>' ); // fetch data
 * singleSelectAndSearchService.cancel(); // cancel an active request
 */
export class SingleSelectAndSearchService extends HttpService {

    // make request and fetch data
    async fetchOptions( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    data
                },
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    options: get( response, 'body.component.data.options', [] ),
                },
            };
            
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
